import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';
import { localizeSystemText } from '../../i18n/messages';
import Input from "../common/Input";
import SelectInput from "../common/SelectInput";
import { CLIENT_LEDGER_ENTRY_TYPES, PAYMENT_METHOD_OPTIONS } from "./clientLedgerTypes";

function ClientLedgerForm({
  entry,
  errors,
  onChange,
  onSubmit,
  isEditing,
  onCancel,
  showTypeSelector,
  fixedTypeLabel,
  settlementMonthReadOnly,
}) {
  const { t: tr } = useTranslation();
  return (
    <form id="client-ledger-form" onSubmit={onSubmit}>
      <Input type="number" label={tr('billing:yearScope.entryYear')} name="schoolYearStartYear" value={String(entry.schoolYearStartYear || '')} onChange={onChange} error={errors.schoolYearStartYear} />
      <div className="form-row">
        <div className="col-md-3">
          {showTypeSelector ? (
            <SelectInput
              label={tr("manage:type_129")}
              name="type"
              value={entry.type}
              onChange={onChange}
              options={[
                { value: CLIENT_LEDGER_ENTRY_TYPES.PAYMENT, text: tr("common:legacyOption14") },
                { value: CLIENT_LEDGER_ENTRY_TYPES.OPENING_BALANCE, text: tr("manage:extraOpeningBalance_22") },
              ]}
              error={errors.type}
            />
          ) : (
            <div className="form-group">
              <span><strong>{tr("manage:type_129")}</strong></span>
              <div className="form-control mt-1 bg-light">{fixedTypeLabel}</div>
            </div>
          )}
        </div>
        <div className="col-md-3">
          <Input type="date" label={tr("manage:date_8")} name="date" value={entry.date} onChange={onChange} error={errors.date} />
        </div>
        <div className="col-md-3">
          <Input
            label={settlementMonthReadOnly ? tr("manage:extraPaymentMonth_23") : tr("manage:month_133")}
            name="settlementMonth"
            value={entry.settlementMonth}
            onChange={onChange}
            placeholder="YYYY-MM"
            readOnly={settlementMonthReadOnly}
            error={errors.settlementMonth}
          />
        </div>
        <div className="col-md-3">
          <Input label={tr("manage:amount_131")} name="amount" value={entry.amount} onChange={onChange} error={errors.amount} />
        </div>
      </div>
      <div className="form-row">
        <div className="col-md-3">
          <SelectInput
            label={tr("manage:method_132")}
            name="method"
            value={entry.method}
            onChange={onChange}
            options={PAYMENT_METHOD_OPTIONS.map(option => ({ ...option, text: localizeSystemText(option.text, tr) }))}
            defaultOption="Wybierz metode"
            error={errors.method}
          />
        </div>
        <div className="col-md-9">
          <Input label={tr("manage:note_17")} name="note" value={entry.note} onChange={onChange} />
        </div>
      </div>
      <button type="submit" className="btn manage-button manage-red-button mr-2">{isEditing ? tr("manage:saveChanges_11") : tr("manage:extraAddEntry_25")}</button>
      {isEditing && (
        <button type="button" className="btn manage-button manage-teal-button" onClick={onCancel}>{tr("common:cancel")}</button>
      )}
    </form>
  );
}

ClientLedgerForm.propTypes = {
  entry: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isEditing: PropTypes.bool,
  onCancel: PropTypes.func,
  showTypeSelector: PropTypes.bool,
  fixedTypeLabel: PropTypes.string,
  settlementMonthReadOnly: PropTypes.bool,
};

ClientLedgerForm.defaultProps = {
  isEditing: false,
  onCancel: () => {},
  showTypeSelector: true,
  fixedTypeLabel: "Wplata",
  settlementMonthReadOnly: false,
};

export default ClientLedgerForm;
